module.exports = __webpack_public_path__ + "static/img/1.85bce52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/1.png
// module id = 4nG7
// module chunks = 0